import React from 'react';
import { CTAButton } from './CTAButton';
import { Flame, Clock, Shield } from 'lucide-react';
const tips = [{
  icon: Flame,
  text: 'Apagá la inflamación sistémica desde la primera comida.'
}, {
  icon: Clock,
  text: 'Plan de 21 días diseñado para la realidad argentina.'
}, {
  icon: Shield,
  text: 'Herramientas de alivio inmediato (30 min) para crisis de dolor.'
}];
export function HeroSection() {
  const scrollToPlan = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('elegir-plan')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-marfil flex flex-col items-center px-4 pt-1 pb-4 min-h-[100svh] max-h-[844px] overflow-hidden" data-id="element-69">
      {/* Navbar — 32px */}
      <nav className="w-full max-w-md h-8 flex items-center justify-center" data-id="element-70">
        <span className="font-serif font-bold text-petroleo text-base tracking-tight" data-id="element-71">
          Biología Femenina
        </span>
      </nav>

      <div className="w-full max-w-md flex flex-col flex-grow justify-center items-center text-center gap-2" data-id="element-72">
        {/* Overline */}
        <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-salvia mt-1" data-id="element-73">
          Para mujeres cansadas de normalizar el dolor pélvico
        </p>

        {/* Headline */}
        <h1 className="font-serif font-bold text-petroleo text-[22px] leading-tight tracking-tight" data-id="element-74">
          Apagá el fuego de la inflamación en 21 días.
        </h1>

        {/* Subheadline */}
        <p className="font-sans text-gray-600 text-[13px] leading-snug px-2" data-id="element-75">
          Un protocolo biológico diseñado para la realidad argentina. Sin dietas
          imposibles ni pastillas extra: recuperá el control de tu cuerpo y
          volvé a sentirte vos.
        </p>

        {/* Mockup Image */}
        <div onClick={scrollToPlan} className="cursor-pointer group" data-id="element-76">
          <div className="relative" data-id="element-77">
            <img src="https://cdn.magicpatterns.com/uploads/jqqzewP2m6WeZnAVKJhNk8/IMG_7845.png" alt="Protocolo Endo-Rescate" loading="eager" className="w-44 h-auto object-contain drop-shadow-xl group-hover:scale-105 transition-transform" data-id="element-78" />
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-36 h-6 bg-gradient-to-b from-petroleo/8 to-transparent rounded-full blur-md" data-id="element-79" />
          </div>
        </div>

        {/* 3 Impact Tips */}
        <div className="w-full flex flex-col gap-1.5 mt-1" data-id="element-80">
          {tips.map((tip, i) => <div key={i} className="flex items-start gap-2 text-left px-1" data-id="element-81">
              <div className="bg-salvia-light p-1 rounded-md flex-shrink-0 mt-0.5" data-id="element-82">
                <tip.icon className="w-3.5 h-3.5 text-salvia" data-id="element-83" />
              </div>
              <p className="text-gray-700 text-[13px] leading-snug" data-id="element-84">
                {tip.text}
              </p>
            </div>)}
        </div>

        {/* CTA */}
        <div className="w-full mt-2 flex flex-col gap-1.5" data-id="element-85">
          <CTAButton text="Quiero mi Protocolo — $19.990" className="!bg-salvia hover:!bg-salvia/90" data-id="element-86" />
          <p className="text-[11px] text-gray-500 font-medium" data-id="element-87">
            🔒 Pago seguro con Mercado Pago · Descarga instantánea
          </p>
        </div>
      </div>
    </section>;
}